<template>
  <template v-if="!inline">
  <!-- UI -->
  <nav class="custom-nav blue-grey darken-3 hide-on-small-only"></nav>

  <nav class="nav-extended blue-grey darken-3 hide-on-small-only">
    <div class="nav-wrapper container">
      <a href="#!" class="brand-logo" @click.prevent="handleActive(home)">{{ home?.name }}</a>
      <ul class="right hide-on-med-and-down">
        <li v-for="tab in tabs" :key="tab.id" :class="{ 'active blue-grey darken-2': tab.id == currTab.id }">
          <a href="#" @click.prevent="handleActive(tab)">{{ tab.title }}</a>
        </li>
      </ul>
    </div>
    <div class="nav-content container">
      <a class="btn-floating btn-large halfway-fab waves-effect waves-light left red darken-2" title="Close"
        @click.prevent="handleRestart()">
        <i class="material-icons white-text">close</i>
      </a>
      <br />
    </div>
  </nav>

  <!-- Mobile only  -->
  <nav class="blue-grey darken-4 hide-on-large-only">
    <ul class="tabs tabs-transparent">
      <li v-for="tab in tabs" :key="tab.id" class="tab" :class="{ 'active': tab.id == currTab.id }">
        <a href="#" @click.prevent="handleActive(tab)">{{ tab?.title?.split(" ")[0] }}</a>
        <!-- <a href="#" @click.prevent="handleActive(tab)" v-else>{{ tab.title }}</a> -->
      </li>
    </ul>
  </nav>

  <!-- breadcrumbs -->
  <nav class="grey lighten-4 z-depth-0">
    <div class="container nav-wrapper">
      <div class="col s12">
        <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i>
            Dashboard</small></router-link>
        <router-link to="/auth" class="breadcrumb blue-grey-text text-darken-3"><small> Authorization
            Home</small></router-link>
        <span class="breadcrumb blue-grey-text pointable"><small>Review</small></span>
      </div>
    </div>
  </nav>
  </template>

  <!-- search layer -->
  <!-- <div class="grey lighten-4">
    <div class="container section"></div>
  </div> -->


  <div :class="[inline ? 'auth-inline-detail' : 'container', 'sba-slide-in']">
    <br v-if="!inline" />
    <div class="auth-inline-leader" v-if="inline && encounter">
      <div class="auth-inline-leader-main">
        <span class="auth-inline-status" :class="{ 'is-waiting': encounter.claims?.length }">
          <i class="material-icons">{{ encounter.claims?.length ? "pending_actions" : "verified_user" }}</i>
        </span>
        <div>
          <label class="active teal-text">Authorization Request</label>
          <h5>{{ encounter.name.toUpperCase() }}</h5>
          <p>
            <span>{{ encounter?.provider?.name || "Provider not recorded" }}</span>
            <span class="auth-inline-dot"></span>
            <strong>{{ encounter.enrollee_number }}</strong>
          </p>
          <div class="auth-inline-meta-chips">
            <span>{{ encounter.scheme?.name?.toUpperCase() || "NO SCHEME" }}</span>
            <span>{{ showAgeSex(encounter?.dob, encounter?.sex)?.toUpperCase() }}</span>
            <span>
              {{
                new Date(encounter?.encounter_date).toLocaleString(undefined, {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })
              }}
            </span>
            <span class="is-locked" v-if="claimsLocked">
              <i class="material-icons">lock</i>{{ claimsLockLabel }}
            </span>
            <span class="is-locked" v-else-if="encounterAddLocked">
              <i class="material-icons">lock</i>{{ addAuthLockLabel }}
            </span>
          </div>
        </div>
      </div>

      <button class="btn-flat auth-inline-close" title="Close" @click.prevent="handleRestart">
        <i class="material-icons left">close</i>Close
      </button>
    </div>

    <div class="progress auth-inline-review-progress" v-if="isRefreshing">
      <div class="indeterminate"></div>
    </div>

    <div class="section center" :class="{ 'auth-inline-switch': inline }">
      <span v-for="tab in tabsState" :key="tab.id" :class="{
        'tab-custom-active': tab.id == currState.id,
        'tab-custom': tab.id != currState.id,
        'left blue-text': tab.title == 'Back',
      }" @click="handleActiveState(tab)">
        <i class="material-icons left" v-if="tab.title == 'Back'">arrow_back</i> {{ tab.title }}
        <span class="auth-message-tab-new" v-if="tab.title === 'Messages' && showMessageTabNew"
          aria-label="New unread messages">New</span>
      </span>
    </div>

    <div class="auth-created-guide" v-if="inline && justCreated && encounter">
      <div class="auth-created-guide-icon">
        <i class="material-icons">verified</i>
      </div>
      <div class="auth-created-guide-copy">
        <span>Authorization request created</span>
        <p>
          You are now viewing the newly registered authorization detail for
          <strong>{{ encounter.name.toUpperCase() }}</strong>. Review the request below, or return to the main request page.
        </p>
      </div>
      <button type="button" class="auth-created-guide-action" @click.prevent="handleRestart">
        <i class="material-icons">arrow_back</i>
        <span>Go Back Home</span>
      </button>
    </div>

    <LoadingDiv v-if="!isReady" />

    <div v-else>
      <div v-if="encounter">

        <div class="section">
          <div class="card z-depth-0 grey lighten-4 auth-inline-inner-card">
            <template v-if="!inline">
              <br />
              <span class="new badge left" data-badge-caption="Scheme">{{
                encounter.scheme.name.toUpperCase()
              }}</span>

              <!-- Encounter -->
              <div class="card-content">
                <div class="row">
                  <div class="col s8">
                    <p>{{ encounter?.provider?.name }}</p>
                    <h5>
                      {{ encounter.name.toUpperCase() }}
                      <sup><small><span class="chip black-text">{{
                        showAgeSex(encounter?.dob, encounter?.sex)
                            }}</span></small></sup>
                      <!-- &nbsp; <a href="#" class="orange-text"><i class="material-icons teal lighten-4" title="go back"
                          @click.prevent="handleRestart()">clear</i></a> -->
                    </h5>
                   <h5> <small> ({{ encounter.enrollee_number }})</small> </h5>
                    <p>
                      <br />
                      <span class="chip black white-text">
                        {{
                          new Date(encounter?.encounter_date).toLocaleString(undefined, {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })
                        }}
                      </span>
                    </p>
                  </div>
                  <div class="col s4">
                    <img :src="encounter.profile_img" width="192" class="circle responsive-img right"
                      v-if="encounter.profile_img" />
                    <img :src="`https://ui-avatars.com/api/?name=${encounter.name}&size=128`" width="192"
                      class="circle responsive-img right" v-else />
                  </div>
                </div>
              </div>
            </template>

            <!-- Entire Provider (diagnosis, claims) Display starts here -->
            <template v-if="currState.title == 'Review'">
              <div class="card grey lighten-4 auth-inline-review-card" :class="{ 'has-add-auth': addAuth }">

                <div id="claim"></div>

                <!-- Display Diagnosis -->
                <div class="auth-diagnosis-card">
                  <div class="auth-diagnosis-icon">
                    <i class="material-icons">bookmark_border</i>
                  </div>
                  <div class="auth-diagnosis-copy">
                    <span>Diagnosis</span>
                    <p v-if="encounter?.diagnosis">{{ encounter?.diagnosis }}</p>
                    <p class="is-muted" v-else>Not recorded</p>
                  </div>
                </div>

                <!-- Add new Auth -->
                <a class="btn-floating btn-large halfway-fab waves-effect waves-light"
                  :class="{ 'disabled': isSubmitting || lock || addAuthLocked, 'red': addAuth, 'blue': !addAuth }"
                  :title="addAuthLocked ? addAuthLockLabel : `${addAuth ? 'cancel' : 'Add Authorization'}`" @click.prevent="handleAddAuth">
                  <i class="material-icons">{{ addAuth ? "cancel" : "add" }}</i>
                </a>

                <!-- Claims Display Card -->
                <div class="card grey lighten-5 auth-inline-items-card" v-if="encounter.claims.length">
                  <div class="card-content">
                    <span class="card-title">Item(s)

                      <!-- <a
                    class="btn-medium waves-effect waves-light blue lighten-2 secondary-content chip right"><i
                      class="material-icons white-text" @click.prevent="handleAddAuth"
                      title="add New Item">add</i>
                    </a> -->

                    </span>

                    <div class="auth-mixed-section-heading is-pending" v-if="hasMixedReviewStates">
                      <span>
                        <i class="material-icons">pending_actions</i>
                        <strong>Pending review</strong>
                      </span>
                      <small>{{ pendingReviewCount }} {{ pendingReviewCount === 1 ? "request" : "requests" }} requiring attention</small>
                    </div>

                    <!-- Auth Request -->
                    <ol id="item-list" class="collection">
                      <template v-for="claim in orderedReviewClaims" :key="claim.id">
                      <li
                        class="collection-item auth-line-item"
                        :class="[claimLineClass(claim), {
                          'is-review-readonly': isReviewReadOnlyClaim(claim) && !(hasMixedReviewStates && isReviewedAuthorizationClaim(claim)),
                          'is-reviewed-authorization': isReviewedAuthorizationClaim(claim),
                          'is-claim-item': isBackendClaimItem(claim),
                          'is-mixed-history-row': isMixedHistoryClaim(claim),
                          'has-inline-resolver': editClaim?.id === claim.id || deleteClaim?.id === claim.id,
                          'is-inline-editing': editClaim?.id === claim.id,
                          'is-inline-deleting': deleteClaim?.id === claim.id,
                        }]"
                      >
                        <template v-if="encounter.status == 'd'">

                          <!-- Deleted Encounter Items -->
                          <span class="auth-line-copy">
                            <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                              Number(claim.sent_price)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }})</s>
                            <b><span class="info-item tooltipped pointable" data-position="top"
                                :data-tooltip="claim.comment">
                                <i class="material-icons grey-text">help</i>
                              </span></b>

                            <!-- Authorizations (delete) -->
                            <span v-if="claim.authorization == 'y'">
                              => <s> ({{ claim.authorization_code }}) </s>
                            </span>
                          </span>

                        </template>

                        <template v-else-if="!canReviewAuthorization || (hasMixedReviewStates && isReviewedAuthorizationClaim(claim))">
                          <!-- Closed / read-only review items -->
                          <span class="auth-line-copy" v-if="claim.authorization == 'y'">
                            <template v-if="isApprovedAsSent(claim)">
                              <b>{{ claim.item }}</b> x {{ claim.sent_qty }}
                              ({{ toMoney(claim.sent_price) }}) <span v-if="Number(claim.sent_price) != 0">-> (Approved)</span> ->
                              <span class="blue-text tooltipped pointable" data-position="top" :data-tooltip="claim.comment"
                                v-if="claim.comment">({{ claim.authorization_code }})</span>
                              <span class="black-text" v-else>({{ claim.authorization_code }})</span>

                              <span class="secondary-content pointable auth-readonly-line-icon"
                                :class="{ 'black-text': Number(claim.sent_price) == 0, 'green-text': Number(claim.sent_price) != 0 }"
                                :title="Number(claim.sent_price) == 0 ? 'Completed' : 'Approved'">
                                <i class="material-icons hide-on-small-only">check_circle</i>
                                <i class="tiny material-icons hide-on-med-and-up">check_circle</i>
                              </span>
                            </template>
                            <template v-else>
                              <b>{{ claim.item }}</b> x {{ claim.sent_qty }} (Charged:
                              {{ toMoney(claim.sent_price) }}) -> x {{ claim.approved_qty }} (Approved:
                              <b>{{ toMoney(claim.approved_price) }}</b>) ->
                              <span class="blue-text text-darken-4 tooltipped pointable" data-position="top"
                                :data-tooltip="claim.comment" v-if="claim.comment">({{ claim.authorization_code }})</span>
                              <span class="black-text" v-else>({{ claim.authorization_code }})</span>

                              <span
                                class="secondary-content green-text pointable auth-readonly-line-icon"
                                :class="{ tooltipped: claim.comment }"
                                data-position="top"
                                :data-tooltip="claim.comment"
                                :title="claim.comment || 'Approved'"
                              >
                                <i class="material-icons hide-on-small-only">check_circle</i>
                                <i class="tiny material-icons hide-on-med-and-up">check_circle</i>
                              </span>
                            </template>
                          </span>

                          <span class="auth-line-copy auth-normal-line" v-else-if="claim.authorization == 'n' && claim.status == 'a'">
                            <b>{{ claim.item }}</b> x {{ claim.sent_qty }} ({{ toMoney(claim.sent_price) }})
                            <span class="auth-care-state-chip is-normal is-static">Claim item</span>
                          </span>

                          <span class="auth-line-copy" v-else-if="claim.authorization == 'z' && claim.status == 'd'">
                            <s>
                              <span class="tooltipped pointable" data-position="top" :data-tooltip="claim.comment"
                                v-if="claim.comment">
                                <b>{{ claim.item }}</b> x {{ claim.sent_qty }} (Charged: {{ toMoney(claim.sent_price) }})
                              </span>

                              <span v-else>
                                <b>{{ claim.item }}</b> x {{ claim.sent_qty }} (Charged: {{ toMoney(claim.sent_price) }})
                              </span>
                            </s>

                            <span
                              class="secondary-content red-text pointable auth-readonly-line-icon"
                              :class="{ tooltipped: claim.comment }"
                              data-position="top"
                              :data-tooltip="claim.comment"
                              :title="claim.comment || 'Declined'"
                            >
                              <i class="material-icons hide-on-small-only">cancel</i>
                              <i class="tiny material-icons hide-on-med-and-up">cancel</i>
                            </span>
                          </span>

                          <span class="auth-line-copy" v-else-if="claim.authorization == 'z' && claim.status == 'a'">
                            <b>{{ claim.item }}</b> x {{ claim.sent_qty }} ({{ toMoney(claim.sent_price) }})
                            <span class="auth-care-state-chip is-primary is-static" v-if="isPrimaryCareApproval(claim)">Primary item</span>
                          </span>
                        </template>

                        <template v-else>
                          <!-- Pending Items -->
                          <span class="auth-line-copy" v-if="claim.authorization == 'z' && claim.status == 'a'">
                            <b>{{ capWords(claim.item) }}</b> x {{ claim.sent_qty }} (₦{{
                              Number(claim.sent_price)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }})
                            <span class="auth-care-state-chip is-primary" :class="{ 'is-static': !canReviewAuthorization }" v-if="isPrimaryCareApproval(claim)">Primary item</span>

                            <!-- Reviewed claim -->
                            <span class="brown-text" v-if="claim.sent_price != claim.approved_price">
                              <b> =></b>

                              <span v-if="claim.sent_qty != claim.approved_qty"> x {{ claim.approved_qty }} </span>

                              <b> (₦{{
                                Number(claim.approved_price)
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }})<span class="info-item tooltipped pointable" data-position="top"
                                  :data-tooltip="capWords(claim.comment)">
                                  <i class="material-icons grey-text">help</i>
                                </span></b>
                            </span>

                            <!-- Authorizations (active) -->
                            <span v-if="claim.authorization == 'y'">
                              => ({{ claim.authorization_code }})
                              <span class="info-item tooltipped secondary-content pointable" data-position="top"
                                :data-tooltip="claim?.slug">
                                <i class="material-icons">lock_outline</i>
                              </span>
                            </span>

                            <!-- Actions -->
                            <span class="line-item-actions"
                              v-if="!isSubmitting && canReviewAuthorization && isSecondaryCareApproval(claim) && editClaim?.id !== claim.id && deleteClaim?.id !== claim.id">
                              <template v-if="isSecondaryCareApproval(claim)">
                                <a href="#" class="secondary-content cancel-item"
                                  @click.prevent="handleReview(claim, 'delete')" title="delete">
                                  <i class="material-icons hide-on-small-only" :class="{
                                    'grey-text': deleteClaim?.id !== claim.id,
                                    'red-text': deleteClaim?.id === claim.id,
                                  }">cancel</i>
                                  <i class="tiny material-icons hide-on-med-and-up" :class="{
                                    'grey-text': deleteClaim?.id !== claim.id,
                                    'red-text': deleteClaim?.id === claim.id,
                                  }">cancel</i>
                                </a>

                                <a href="#" class="secondary-content edit-item"
                                  @click.prevent="handleReview(claim, 'edit')" title="edit">
                                  <i class="material-icons hide-on-small-only" :class="{
                                    'grey-text': editClaim?.id !== claim.id,
                                    'blue-text': editClaim?.id === claim.id,
                                  }">edit</i>
                                  <i class="tiny material-icons hide-on-med-and-up" :class="{
                                    'grey-text': editClaim?.id !== claim.id,
                                    'blue-text': editClaim?.id === claim.id,
                                  }">edit</i>
                                </a>
                              </template>

                              <a href="#" class="secondary-content return-normal-item"
                                @click.prevent="handleCareAuthorization(claim, 'normal')" title="Return to normal claim item">
                                <i class="material-icons hide-on-small-only grey-text">undo</i>
                                <i class="tiny material-icons hide-on-med-and-up grey-text">undo</i>
                              </a>
                            </span>
                          </span>

                          <!-- Normal Claim Items -->
                          <span class="auth-line-copy auth-normal-line" v-if="claim.authorization == 'n' && claim.status == 'a'">
                            <a href="#" class="auth-line-transition-prefix"
                              :class="{ 'is-returned': isReturnedNormalClaim(claim) }"
                              @click.prevent="handleCareAuthorization(claim, 'secondary')"
                              title="Keep as secondary care item"
                              v-if="!isSubmitting && canReviewAuthorization && isReturnedNormalClaim(claim)">
                              <i class="material-icons">undo</i>
                            </a>
                            <b>{{ capWords(claim.item) }}</b> x {{ claim.sent_qty }} ({{ toMoney(claim.sent_price) }})
                            <span class="auth-care-state-chip is-return" :class="{ 'is-static': !canReviewAuthorization }" v-if="isReturnedNormalClaim(claim)">Will return to normal claim item</span>
                            <span class="auth-care-state-chip is-normal" :class="{ 'is-static': !canReviewAuthorization }" v-else>Claim item</span>
                          </span>

                          <!-- Approved Items -->
                          <span class="auth-line-copy" v-if="claim.authorization == 'y'">
                            <b>{{ capWords(claim.item) }}</b> x {{ claim.sent_qty }} ({{ toMoney(claim.sent_price) }})
                            <span v-if="claim.authorization_code">({{ claim.authorization_code }})</span>
                            <span class="auth-reviewed-lock-chip" v-if="isReviewedAuthorizationClaim(claim)" title="Already reviewed">
                              <i class="material-icons">lock</i>
                              <span>Reviewed</span>
                            </span>
                          </span>

                          <!-- Deleted Items -->
                          <span class="auth-line-copy" v-if="claim.authorization == 'z' && claim.status == 'd'">
                            <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                              Number(claim.sent_price)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }})</s>
                            <b><span class="info-item tooltipped pointable" data-position="top"
                                :data-tooltip="capWords(claim.comment)">
                                <i class="material-icons grey-text">help</i>
                              </span></b>
                            <span class="auth-care-state-chip is-declined" :class="{ 'is-static': !canReviewAuthorization }" v-if="isDeclinedSecondaryCare(claim)">Declined</span>
                            <span class="auth-reviewed-lock-chip is-declined" v-else-if="isReviewedAuthorizationClaim(claim)" title="Already reviewed">
                              <i class="material-icons">lock</i>
                              <span>Reviewed</span>
                            </span>

                            <!-- Actions -->
                            <span class="line-item-actions" v-if="canReviewAuthorization && isDeclinedSecondaryCare(claim)">
                              <a href="#" class="secondary-content reset-item" @click.prevent="handleReset(claim)"
                              title="reset"><i class="small material-icons grey-text">refresh</i></a>
                            </span>
                          </span>
                        </template>

                        <form class="auth-item-resolver" :id="`auth-item-resolver-${claim.id}`"
                          :class="{ 'is-editing': editClaim?.id === claim.id, 'is-deleting': deleteClaim?.id === claim.id }"
                          @submit.prevent="handleUpdate()"
                          v-if="canReviewAuthorization && (editClaim?.id === claim.id || deleteClaim?.id === claim.id)">
                          <div class="auth-item-resolver-heading">
                            <span class="auth-item-resolver-icon">
                              <i class="material-icons">{{ editClaim?.id === claim.id ? "tune" : "delete_outline" }}</i>
                            </span>
                            <span>
                              <strong>{{ editClaim?.id === claim.id ? "Adjust authorization" : "Decline authorization" }}</strong>
                              <small>{{ capWords(claim.item) }}</small>
                            </span>
                            <button type="button" class="auth-item-resolver-dismiss" title="Close resolver"
                              aria-label="Close resolver" @click.prevent="handleClear()">
                              <i class="material-icons">close</i>
                            </button>
                          </div>

                          <div class="auth-item-resolver-fields" v-if="editClaim?.id === claim.id">
                            <label :for="`auth-qty-${claim.id}`">
                              <span>Approved quantity</span>
                              <input v-model="qty" @input="handlePricing" :id="`auth-qty-${claim.id}`" type="number"
                                min="1" required />
                            </label>
                            <label :for="`auth-amount-${claim.id}`">
                              <span>Approved amount</span>
                              <input v-model="amt" :id="`auth-amount-${claim.id}`" type="number" readonly />
                            </label>
                          </div>

                          <label class="auth-item-resolver-comment" :for="`auth-comment-${claim.id}`">
                            <span>{{ deleteClaim?.id === claim.id ? "Reason for declining" : "Review comment" }}</span>
                            <input v-model="comment" :id="`auth-comment-${claim.id}`" type="text"
                              :placeholder="deleteClaim?.id === claim.id ? 'Enter the reason for declining this item' : 'Add a comment for this adjustment'"
                              required />
                          </label>

                          <div class="auth-item-resolver-actions">
                            <button type="button" class="auth-item-resolver-cancel" @click.prevent="handleClear()">
                              {{ deleteClaim?.id === claim.id ? "Keep item" : "Cancel" }}
                            </button>
                            <button type="submit" class="auth-item-resolver-submit"
                              :class="{ 'is-danger': deleteClaim?.id === claim.id }">
                              <i class="material-icons">{{ editClaim?.id === claim.id ? "check" : "close" }}</i>
                              <span>{{ editClaim?.id === claim.id ? "Apply adjustment" : "Decline item" }}</span>
                            </button>
                          </div>
                        </form>
                      </li>

                      <li class="collection-item auth-mixed-action-zone"
                        v-if="hasMixedReviewStates && claim.id === lastPendingReviewClaimId">
                        <div class="auth-mixed-action-heading">
                          <span>
                            <i class="material-icons">task_alt</i>
                            <strong>Complete pending review</strong>
                          </span>
                          <small>Review the past activity below before confirming these decisions.</small>
                        </div>

                        <ul class="auth-submit-summary" v-if="hasSubmitWork && canReviewAuthorization && !showApproveConfirm">
                          <li v-for="row in authSubmitSummaryRows" :key="row.id" :class="`is-${row.id}`">
                            <i class="material-icons">{{ row.icon }}</i>
                            <span>{{ row.label }}</span>
                          </li>
                        </ul>

                        <ul class="collection auth-mixed-total-list" v-if="hasSubmitWork && canReviewAuthorization && !showApproveConfirm">
                          <li class="collection-item pull-right auth-total-row">
                            <span>
                              <b>Total</b> <em>(for approval)</em>:
                              <b><span class="red-text">&#8358;{{ totalApproved(encounter?.claims) }}</span></b>
                            </span>
                            <span class="auth-grand-total">
                              Grand total: &#8358;{{ totalClaimValue(encounter?.claims) }}
                            </span>
                          </li>
                        </ul>

                        <div class="auth-mixed-action-buttons">
                          <a class="waves-effect waves-light btn-large auth-inline-back-action" @click.prevent="handleRestart">
                            <i class="medium material-icons left">chevron_left</i>Back
                          </a>

                          <button class="waves-effect waves-light btn-large green auth-submit-action"
                            v-if="hasSubmitWork && canReviewAuthorization" :class="{
                              disabled: isSubmitting || claimsLocked || !hasSubmitWork,
                            }" :disabled="isSubmitting || claimsLocked || !hasSubmitWork"
                            @click.prevent="openApproveConfirm">
                            <i class="large material-icons left">check_circle</i>{{
                              isSubmitting ? "Submitting ..." : "Submit decisions" }}
                          </button>
                        </div>

                        <Teleport to="body">
                          <div class="auth-inline-confirm-layer" v-if="showApproveConfirm">
                            <div class="auth-inline-confirm-card">
                              <div class="auth-inline-confirm-content">
                                <h4>{{ alertTitle }}</h4>
                                <p>{{ alertMessage }}</p>
                                <ul class="auth-submit-summary" v-if="authSubmitSummaryRows.length">
                                  <li v-for="row in authSubmitSummaryRows" :key="row.id" :class="`is-${row.id}`">
                                    <i class="material-icons">{{ row.icon }}</i>
                                    <span>{{ row.label }}</span>
                                  </li>
                                </ul>
                                <div class="auth-confirm-total">
                                  <span>Approved total</span>
                                  <strong>&#8358;{{ totalApproved(encounter?.claims) }}</strong>
                                </div>
                              </div>
                              <div class="auth-inline-confirm-actions">
                                <button type="button" @click.prevent="handleConfirm(false)">Cancel</button>
                                <button type="button" @click.prevent="handleConfirm(true)">Confirm</button>
                              </div>
                            </div>
                          </div>
                        </Teleport>
                      </li>

                      <li class="collection-item auth-mixed-section-heading is-reviewed"
                        v-if="hasMixedReviewStates && claim.id === lastPendingReviewClaimId">
                        <span>
                          <i class="material-icons">lock</i>
                          <strong>Previously reviewed</strong>
                        </span>
                        <small>{{ reviewedHistoryCount }} completed {{ reviewedHistoryCount === 1 ? "decision" : "decisions" }}</small>
                      </li>
                      </template>
                    </ol>

                    <!-- Claims Submit -->
                    <div v-if="!hasMixedReviewStates">
                      <ul class="auth-submit-summary" v-if="hasSubmitWork && canReviewAuthorization && !showApproveConfirm">
                        <li v-for="row in authSubmitSummaryRows" :key="row.id" :class="`is-${row.id}`">
                          <i class="material-icons">{{ row.icon }}</i>
                          <span>{{ row.label }}</span>
                        </li>
                      </ul>

                      <!-- Total -->
                      <ul id="item-list" class="collection" v-if="hasSubmitWork && canReviewAuthorization && !showApproveConfirm">
                        <li class="collection-item pull-right auth-total-row">
                          <span>
                            <b>Total</b> <em>(for approval)</em>:
                            <b><span class="red-text">₦{{ totalApproved(encounter?.claims) }}</span></b>
                          </span>
                          <span class="auth-grand-total">
                            Grand total: ₦{{ totalClaimValue(encounter?.claims) }}
                          </span>
                        </li>
                      </ul>

                      <div id="edit"></div>

                      <br />

                      <!-- Submit -->
                      <div class="row">
                        <a class="waves-effect waves-light btn-large col s12 m2 left auth-inline-back-action" @click.prevent="handleRestart">
                          <i class="medium material-icons left">chevron_left</i>Back
                        </a>

                        <!-- Breaker -->
                        <span class="co1 m7"></span>
                        <!-- Submit -->
                        <button class="waves-effect waves-light btn-large green col s12 m3 right auth-submit-action" v-if="hasSubmitWork && canReviewAuthorization" :class="{
                          disabled: isSubmitting || claimsLocked || !hasSubmitWork,
                        }" :disabled="isSubmitting || claimsLocked || !hasSubmitWork" @click.prevent="openApproveConfirm"><i class="large material-icons left">check_circle</i>{{
                          isSubmitting ? "Completing ..." : "Complete" }}
                        </button>
                      </div>

                      <!-- Confirmation -->
                      <Teleport to="body">
                        <div class="auth-inline-confirm-layer" v-if="showApproveConfirm">
                          <div class="auth-inline-confirm-card">
                            <div class="auth-inline-confirm-content">
                              <h4>{{ alertTitle }}</h4>
                              <p>{{ alertMessage }}</p>
                              <ul class="auth-submit-summary" v-if="authSubmitSummaryRows.length">
                                <li v-for="row in authSubmitSummaryRows" :key="row.id" :class="`is-${row.id}`">
                                  <i class="material-icons">{{ row.icon }}</i>
                                  <span>{{ row.label }}</span>
                                </li>
                              </ul>
                              <div class="auth-confirm-total">
                                <span>Approved total</span>
                                <strong>₦{{ totalApproved(encounter?.claims) }}</strong>
                              </div>
                            </div>
                            <div class="auth-inline-confirm-actions">
                              <button type="button" @click.prevent="handleConfirm(false)">Cancel</button>
                              <button type="button" @click.prevent="handleConfirm(true)">Confirm</button>
                            </div>
                          </div>
                        </div>
                      </Teleport>
                    </div>
                  </div>
                </div>

                <!-- Sumbmitting -->
                <div class="progress auth-inline-review-progress" v-if="isSubmitting">
                  <div class="indeterminate"></div>
                </div>

                <!-- <div class="white"><br /></div> -->

                <!-- Add claim -->
                <transition name="auth-add-slide">
                  <div class="auth-inline-add-shell" ref="addAuthPanel" v-if="addAuth">
                    <AddAuthItem
                      :turl="{ sid: encounter?.scheme_id, pid: encounter?.provider_id, opid: encounter?.provider?.opid }"
                      :reset="error" @update="handleAddAuthUpdate" />
                  </div>
                </transition>

                <!-- Edit and Delete Claims -->
                <div class="card" :class="{ 'teal lighten-5': !error, 'red lighten-5': error }"
                  v-if="showLegacyExternalResolver && canReviewAuthorization && (editClaim || deleteClaim)">
                  <div class="card-content">
                    <div class="row">
                      <form class="col s12" @submit.prevent="handleUpdate()">
                        <div class="row">
                          <!-- Main  hide-on-small-only -->
                          <div class="input-field col s12 m6">
                            <input v-model="claim" id="claim" type="text" :readonly="!!deleteClaim" @focus="!deleteClaim && handleClear()" />
                            <label class="active" for="claim">Item</label>
                          </div>
                          <!-- Continue -->
                          <div class="input-field col s6 m3">
                            <input v-model="qty" @input="handlePricing" id="qty" type="number" :disabled="!!deleteClaim" />
                            <label class="active" for="qty">Quantity</label>
                          </div>
                          <div class="input-field col s6 m3">
                            <input v-model="amt" id="amt" type="number" readonly :disabled="!!deleteClaim" />
                            <label class="active" for="amt">Amount Charged</label>
                          </div>
                          <!-- Comment -->
                          <div class="input-field col s12">
                            <input v-model="comment" id="comment" type="text" required />
                            <label class="active" for="comment">Comment</label>
                          </div>

                          <div class="input-field col s12">
                            <a class="waves-effect waves-light btn col s12 m2 auth-inline-back-action auth-inline-item-close-action"
                              @click.prevent="handleClear()">
                              <i class="medium material-icons left">close</i>Close
                            </a>

                            <!-- Breaker -->
                            <span class="co1 m7"></span>

                            <!-- OK -->
                            <button class="waves-effect waves-light btn col s12 m3 right"
                              :class="{ 'indigo darken-2': editClaim?.id, 'red darken-2': deleteClaim?.id }">
                              <i class="medium material-icons left">{{
                                editClaim?.id ? "sync" : "cancel"
                              }}</i>{{ editClaim?.id ? "Edit Item" : "Delete Item" }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

              </div>
            </template>

            <!-- Benefits -->
            <div class="auth-inline-secondary-card" v-if="currState.title == 'Messages'">
              <EncounterMessages ref="encounterMessages" v-model:draft="messageDraft" :encounter-id="encounter.id"
                :initial-messages="encounter?.stores?.encounter_messages || []" />
            </div>

            <!-- Benefits -->
            <div class="auth-inline-secondary-card" v-if="currState.title == 'Benefits'">
              <BenefitsDiv
                v-if="benefitPlanId(encounter) && encounter?.client_id"
                :pid="benefitPlanId(encounter)"
                :cid="encounter.client_id"
              />
            </div>

            <!-- History -->
            <div class="auth-inline-secondary-card" v-if="currState.title == 'History'">
              <HistoryAuth :enrolleeNumber="encounter.enrollee_number"
                :scheme-id="encounter.scheme_id || encounter.scheme?.id" />
            </div>

            <!-- Utilization -->
            <div class="auth-inline-secondary-card" v-if="currState.title == 'Utilization'">
              <UtilizationInsight :encounter="encounter" @reset="handleActiveState(tabsState[0])" />
            </div>

            <!-- Info -->
            <div class="auth-inline-secondary-card" v-if="currState.title == 'Info'">
              <EncounterInfo :encounter="encounter" mode="auth" />
            </div>

          </div>
        </div>

      </div>

      <div class="section center" v-if="!encounter">
        <h6><img src="@/assets/img/no-user.png" width="256" class="circle responsive-img" /></h6>
      </div>


    </div>

  </div>
</template>

<script>
import { ref, onMounted, onUpdated, computed, watch, watchEffect, nextTick } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { toMoneyFx } from "@/composables/calFunction/cal.js";
import { ageSex } from "@/composables/fxLibrary/coreFx";
import postItem from "@/composables/postItem";
import { beginAdminAuthorizationRequest } from "@/composables/authorizationRealtimeCoordinator";
import getItem from "@/composables/getItem";
import AddAuthItem from "@/components/auth/AddAuthItemComponent.vue";
import BenefitsDiv from "@/components/plan/ShowBenefitComponent.vue";
import HistoryAuth from "@/components/auth/HistoryAuthComponent.vue";
import UtilizationInsight from "@/components/insight/UtilizationInsightComponent.vue";
import EncounterInfo from "@/components/encounter/EncounterInfoComponent.vue";
import EncounterMessages from "@/components/encounter/EncounterMessagesComponent.vue";
import { unreadEncounterMessageCount } from "@/composables/encounterMessageReadState";
import LoadingDiv from "@/components/LoadingDiv.vue";
import { ID_NUMBER, ABBR } from '@/laravel/config';
import { capWordsFx } from "@/composables/fxLibrary/coreFx.js";
import { siloMode } from '@/laravel/config';
import M from "materialize-css";


export default {
  name: "AuthInlineReviewComponent",
  props: {
    encounterId: [String, Number],
    inline: {
      type: Boolean,
      default: true,
    },
    justCreated: {
      type: Boolean,
      default: false,
    },
    initialState: {
      type: String,
      default: "",
    },
  },
  emits: ["close", "saved"],
  components: { LoadingDiv, AddAuthItem, BenefitsDiv, HistoryAuth, UtilizationInsight, EncounterInfo, EncounterMessages },
  setup(props, context) {
    const lock = ref(false);
    const response = ref(null);
    const enrolleeDefault = ref([]);
    const originalClaimStates = ref({});
    const selectedItem = ref(null);
    const isReady = ref(false);
    const isLoading = ref(false);
    const isRefreshing = ref(false);
    const pendingRealtimeRefresh = ref(false);
    const isSubmitting = ref(false);
    const alertTitle = ref("Confirm");
    const alertMessage = ref("Are you sure? Kindly confirm items for accuracy. Once submitted, changes cannot be made.");
    const home = ref(null);
    const tabs = ref([]);
    const currTab = ref(null);
    const tabsState = ref([]);
    const currState = ref(null);
    const error = ref(false);
    const addAuth = ref(false);
    const editClaim = ref(null);
    const deleteClaim = ref(null);
    const standard = ref(null);
    const comment = ref(null);
    const claim = ref(null);
    const qty = ref(null);
    const amt = ref(null);
    const getResource = ref(null);
    const postResource = ref(null);
    const addAuthPanel = ref(null);
    const showApproveConfirm = ref(false);
    const showLegacyExternalResolver = false;
    const encounterMessages = ref(null);
    const messageDraft = ref("");

    // vue router
    const router = useRouter();

    // store
    const store = useStore();
    const showMessageTabNew = computed(() => currState.value?.title !== "Messages"
      && unreadEncounterMessageCount(store.state.user, props.encounterId) > 0);

    // start
    onMounted(() => {
      // page name
      if (!props.inline) {
        document.title = "Approval Authorization";
      }
    });

    // sort silo
    onMounted(() => {
      // sort
      getResource.value = getItem;
      postResource.value = postItem;
    });

    // start
    const validityChecker = (val) => {
      // only for remote calls
      if (siloMode) return;

      // checker
      if (ID_NUMBER !== val?.payer_id) {
        // return
        handleRestart();
      }
    }

    const snapshotClaimStates = (claims = []) => {
      return claims.reduce((states, claim) => {
        states[claim.id] = {
          authorization: claim.authorization,
          status: claim.status,
        };

        return states;
      }, {});
    };

    const originalClaimState = (claim) => {
      return originalClaimStates.value[claim?.id] || {};
    };

    const isOriginalActiveAuthorizationClaim = (claim) => {
      const original = originalClaimState(claim);

      return original.authorization === "z"
        && original.status === "a";
    };

    const isPrimaryCareApproval = (claim) => {
      const original = originalClaimState(claim);

      return original.authorization === "n"
        && original.status === "a"
        && claim?.authorization === "z"
        && claim?.status === "a";
    };

    const isSecondaryCareApproval = (claim) => {
      return isOriginalActiveAuthorizationClaim(claim)
        && claim?.authorization === "z"
        && claim?.status === "a";
    };

    const isReturnedNormalClaim = (claim) => {
      const original = originalClaimState(claim);

      return original.authorization === "z"
        && original.status === "a"
        && claim?.authorization === "n"
        && claim?.status === "a";
    };

    const isDeclinedSecondaryCare = (claim) => {
      const original = originalClaimState(claim);

      return original.authorization === "z"
        && original.status === "a"
        && claim?.authorization === "z"
        && claim?.status === "d";
    };

    const isReviewedAuthorizationClaim = (claim) => {
      if (claim?.authorization === "y") {
        return true;
      }

      return claim?.authorization === "z"
        && claim?.status === "d"
        && !isDeclinedSecondaryCare(claim);
    };

    const isReviewEditableClaim = (claim) => {
      return isSecondaryCareApproval(claim)
        || isReturnedNormalClaim(claim)
        || isDeclinedSecondaryCare(claim);
    };

    const isReviewReadOnlyClaim = (claim) => {
      if (!canReviewAuthorization.value || encounter.value?.status === "d") {
        return false;
      }

      return !isReviewEditableClaim(claim);
    };

    const isBackendClaimItem = (claim) => {
      const original = originalClaimState(claim);

      return original.authorization === "n"
        && original.status === "a"
        && claim?.authorization === "n"
        && claim?.status === "a";
    };

    const reviewClaimSortRank = (claim) => {
      const original = originalClaimState(claim);

      if (original.authorization === "z" && original.status === "a") {
        return 0;
      }

      if (claim?.authorization === "y" || (claim?.authorization === "z" && claim?.status === "d")) {
        return 1;
      }

      if (claim?.authorization === "n" && claim?.status === "a") {
        return 2;
      }

      return 3;
    };

    const orderedReviewClaims = computed(() => {
      return (encounter.value?.claims || [])
        .map((claim, index) => ({ claim, index }))
        .sort((a, b) => {
          const rank = reviewClaimSortRank(a.claim) - reviewClaimSortRank(b.claim);
          return rank || a.index - b.index;
        })
        .map(({ claim }) => claim);
    });

    const pendingReviewClaims = computed(() => {
      return orderedReviewClaims.value.filter(isOriginalActiveAuthorizationClaim);
    });

    const reviewedHistoryClaims = computed(() => {
      return orderedReviewClaims.value.filter(isReviewedAuthorizationClaim);
    });

    const hasMixedReviewStates = computed(() => {
      return canReviewAuthorization.value
        && pendingReviewClaims.value.length > 0
        && reviewedHistoryClaims.value.length > 0;
    });

    const lastPendingReviewClaimId = computed(() => {
      return pendingReviewClaims.value[pendingReviewClaims.value.length - 1]?.id || null;
    });

    const pendingReviewCount = computed(() => pendingReviewClaims.value.length);
    const reviewedHistoryCount = computed(() => reviewedHistoryClaims.value.length);

    const isMixedHistoryClaim = (claim) => {
      return hasMixedReviewStates.value && !isOriginalActiveAuthorizationClaim(claim);
    };

    const itemLabel = (count) => count === 1 ? "item" : "items";

    const isApprovedAsSent = (claim) => {
      return Number(claim?.sent_price) === Number(claim?.approved_price);
    };

    const claimLineClass = (claim) => {
      if ((canReviewAuthorization.value && !isReviewedAuthorizationClaim(claim)) || encounter.value?.status === "d") {
        return "";
      }

      if (claim?.authorization === "n" && claim?.status === "a") {
        return "";
      }

      if (claim?.authorization === "z" && claim?.status === "d") {
        return "red lighten-4";
      }

      if (claim?.authorization === "z" && claim?.status === "a") {
        return isPrimaryCareApproval(claim) ? "blue lighten-4" : "amber lighten-4";
      }

      if (claim?.authorization === "y") {
        if (Number(claim?.sent_price) === 0) {
          return "grey lighten-2";
        }

        if (!isApprovedAsSent(claim)) {
          return "blue lighten-4";
        }

        return "green lighten-4";
      }

      return "";
    };

    // start
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Pre-Auth", title: "All", icon: "arrow_back", url: "auth", hash: null, });
      tabs.value.push({ id: 2, name: "Pre-Auth", title: "Add Auth", icon: "add_circle", url: "authAdd", hash: null, });

      // set default
      currTab.value = { id: null };
      // set home
      home.value = tabs.value.find(x => x.url === "auth");
    });


    onMounted(() => {
      // load tab
      // tabsState.value.push({ id: 1, title: "Back" });
      tabsState.value.push({ id: 2, title: "Review" });
      tabsState.value.push({ id: 7, title: "Messages" });
      tabsState.value.push({ id: 3, title: "Benefits" });
      tabsState.value.push({ id: 4, title: "History" });
      tabsState.value.push({ id: 5, title: "Utilization" });
      tabsState.value.push({ id: 6, title: "Info" });
      // set default
      currState.value = tabsState.value.find(tab => tab.title.toLowerCase() === props.initialState.toLowerCase())
        || tabsState.value[0]; // start from Review
    });

    // handle curr status
    const handleActive = (tab) => {
      // refer
      if (tab.hash) {
        router.push({ name: tab.url, hash: tab.hash });
      } else {
        router.push({ name: tab.url });
      }
    };

    // handle curr status
    const handleActiveState = (tab) => {
      // update show and components
      currState.value = tab;
    };

    const benefitPlanId = (val) => {
      return val?.plan_id || val?.plan?.id || val?.principal?.plan_id || val?.principal?.plan?.id || null;
    };

    const claimsLocked = computed(() => {
      const status = encounter.value?.cluster?.status;
      return siloMode && status && status !== "q";
    });

    const claimsLockLabel = computed(() => {
      const status = encounter.value?.cluster?.status;
      return status === "p" ? "Claims submitted" : "Claims closed";
    });

    const encounterAddLocked = computed(() => {
      const status = encounter.value?.status;
      return siloMode && status && status !== "q";
    });

    const addAuthLocked = computed(() => {
      return claimsLocked.value || encounterAddLocked.value;
    });

    const addAuthLockLabel = computed(() => {
      if (claimsLocked.value) {
        return claimsLockLabel.value;
      }

      return "Encounter submitted";
    });

    const hasActiveAuthorizationRequest = computed(() => {
      return (encounter.value?.claims || []).some(x => {
        const original = originalClaimState(x);
        return (original.authorization || x.authorization) === "z"
          && (original.status || x.status) === "a";
      });
    });

    const canReviewAuthorization = computed(() => {
      return !claimsLocked.value && hasActiveAuthorizationRequest.value;
    });

    const moveToSection = (section) => {
      if (props.inline) {
        setTimeout(() => {
          document.getElementById(section)?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 50);
        return;
      }

      router.push({ hash: `#${section}` });
    };

    // get function
    const getSingleItemFromApi = (table, id, options = {}) => {
      const background = options.background === true;

      if (background) {
        isRefreshing.value = true;
        error.value = null;
      }

      return (async () => {
        const { res, err } = await getResource.value(table, id);

        if (res.value) {

          const detailPayload = res.value.data;
          const authHistory = detailPayload.auth_history || detailPayload.claims || [];
          const reviewClaims = siloMode
            ? detailPayload.review_claims || detailPayload.vetting_claims || detailPayload.claims || []
            : detailPayload.vetting_claims || detailPayload.claims || [];

          // set default
          enrolleeDefault.value = JSON.parse(JSON.stringify({
            ...detailPayload,
            claims: authHistory,
          }));

          // get started
          let authEncounter = {
            ...detailPayload,
            claims: reviewClaims,
          };

          // oneProvider still uses the older generic encounter payload
          if (!siloMode) {
            authEncounter.claims = authEncounter.claims.filter(x => x.status === "a" && x.authorization === "z");
          }

          originalClaimStates.value = snapshotClaimStates(authEncounter.claims);

          // merge
          response.value = authEncounter;

          // SECURITY CHECKPOINT
          validityChecker(response.value);

          // // encounter
          // responseEncounter.value = res.value.data;
          // // auths
          // responseAuths.value = res.value.data.claims.filter(
          //   (x) => x.authorization != "n"
          // );
          // // sort auths
          // responseAuths.value.sort((a, b) => {
          //   return a.authorization.localeCompare(b.authorization);
          // });
        } else {
          error.value = err.value;
        }

        // page is ready
        isReady.value = true;
        isRefreshing.value = false;
      })();
    };

    const hasUnsafeRealtimeWork = () => {
      return Boolean(
        isSubmitting.value
        || isRefreshing.value
        || editClaim.value
        || deleteClaim.value
        || addAuth.value
        || showApproveConfirm.value
      );
    };

    const refreshFromServer = () => {
      if (hasUnsafeRealtimeWork()) {
        pendingRealtimeRefresh.value = true;
        return false;
      }

      pendingRealtimeRefresh.value = false;
      getSingleItemFromApi(
        siloMode ? "encounter/auth/detail" : "integration/oneprovider/auth",
        props.encounterId,
        { background: true }
      );
      return true;
    };

    watch(
      [isSubmitting, isRefreshing, editClaim, deleteClaim, addAuth, showApproveConfirm],
      () => {
        if (pendingRealtimeRefresh.value && !hasUnsafeRealtimeWork()) {
          refreshFromServer();
        }
      }
    );

    const refreshMessagesFromServer = () => {
      return encounterMessages.value?.refreshFromServer?.() || false;
    };

    context.expose({ refreshFromServer, refreshMessagesFromServer });

    // toolTip
    const toolTip = () => {
      var elems = document.querySelectorAll(".tooltipped");
      M.Tooltip.init(elems, {});
    };

    // restart toolTip
    const restartComments = () => {
      // load comment
      setTimeout(() => {
        toolTip();
      }, 2000);
    };

    // load after data loads and updates
    watchEffect(() => {
      if (response.value) {
        restartComments();
      }
    });

    // starter
    onMounted(() => {
      // get items from function
      getSingleItemFromApi(siloMode ? "encounter/auth/detail" : "integration/oneprovider/auth", props.encounterId);
    });

    //from functions
    const capWords = (val) => {
      return capWordsFx(val);
    };

    // add up
    const totalApproved = (claims) => {
      let total = 0;
      claims?.forEach((x) => {
        if (x.approved_price && isSecondaryCareApproval(x)) {
          total = Number(total) + priceValue(x.approved_price);
        }
      });
      return total
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const priceValue = (val) => {
      const amount = Number(String(val ?? 0).replace(/,/g, ""));
      return Number.isFinite(amount) ? amount : 0;
    };

    const totalClaimValue = (claims) => {
      let total = 0;

      claims?.forEach((x) => {
        if (x.status === "d") {
          return;
        }

        if (x.authorization === "y") {
          total = Number(total) + priceValue(x.approved_price);
          return;
        }

        total = Number(total) + priceValue(x.sent_price);
      });

      return total
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // to Money
    const toMoney = (val) => {
      return toMoneyFx(val);
    }

    // ageSex
    const showAgeSex = (dob, sex) => {
      const { fx } = ageSex(dob, sex);
      return fx.value;
    };

    // scrollbar
    const resetScrollBar = () => {
      // Restore scrollbar (insurance)
      document.body.style.overflow = 'auto';
    };

    // alert
    onMounted(() => {
      // modal
      const elems = document.querySelectorAll(".modal");
      M.Modal.init(elems, {});

    });

    // alert
    onUpdated(() => {
      // modal
      const elems = document.querySelectorAll(".modal");
      M.Modal.init(elems, {});

    });

    // clear
    const handleClear = () => {
      // clear all
      claim.value = null;
      amt.value = null;
      qty.value = null;
      standard.value = null;
      comment.value = null;
      editClaim.value = null;
      deleteClaim.value = null;
    }

    const revealItemResolver = async (claimId) => {
      await nextTick();

      window.requestAnimationFrame(() => {
        const resolver = document.getElementById(`auth-item-resolver-${claimId}`);

        if (!resolver) {
          return;
        }

        const viewportGap = 24;
        const overflow = resolver.getBoundingClientRect().bottom - (window.innerHeight - viewportGap);

        if (overflow > 0) {
          window.scrollBy({
            top: overflow,
            behavior: "smooth",
          });
        }
      });
    };

    // handle edit
    const handleReview = async (val, type) => {
      if (!canReviewAuthorization.value || !isSecondaryCareApproval(val)) {
        return;
      }

      // refine claim
      claim.value = val.item;
      amt.value = val.sent_price;
      qty.value = val.sent_qty;
      standard.value = val.standard_price;

      // store all
      if (type === "edit") {
        if (editClaim.value?.id === val.id) {
          // clear all
          editClaim.value = null;
          handleClear();
          return;
        }
        comment.value = val.comment;
        editClaim.value = val;
        // clear delete lurking around
        deleteClaim.value = null;
      } else if (type === "delete") {
        if (deleteClaim.value?.id === val.id) {
          // clear all
          deleteClaim.value = null;
          handleClear();
          return;
        }
        comment.value = null;
        deleteClaim.value = val
        // clear edit lurking around
        editClaim.value = null;
      } else {
        // clear all
        handleClear();
        return;
      }

      await revealItemResolver(val.id);

    };

    // watch qty & price
    const handlePricing = () => {
      amt.value = (Number(qty.value) * Number(standard.value)).toFixed(2);
    };

    // handle reset
    const handleReset = (val) => {
      if (!canReviewAuthorization.value || !isDeclinedSecondaryCare(val)) {
        return;
      }

      // revert
      response.value.claims.forEach((x) => {
        if (x.id === val?.id) {
          x.approved_price = x.sent_price;
          x.approved_qty = x.sent_qty;
          x.comment = null;
          x.authorization = "z"; // return to at z
          x.status = "a" // turn to active
        }
      })
    }

    const handleCareAuthorization = (val, action) => {
      if (!canReviewAuthorization.value || isSubmitting.value) {
        return;
      }

      if (!["normal", "secondary"].includes(action)) {
        return;
      }

      if (action === "normal" && !isSecondaryCareApproval(val)) {
        return;
      }

      if (action === "secondary" && !isReturnedNormalClaim(val)) {
        return;
      }

      handleClear();

      response.value.claims.forEach((x) => {
        if (x.id !== val?.id) {
          return;
        }

        if (action === "secondary") {
          x.authorization = "z";
          x.authorization_code = null;
          x.status = "a";
          x.approved_qty = x.approved_qty || x.sent_qty;
          x.approved_price = x.approved_price || x.sent_price;
          x.comment = null;
        }

        if (action === "normal") {
          x.authorization = "n";
          x.authorization_code = null;
          x.status = "a";
          x.approved_qty = null;
          x.approved_price = null;
          x.comment = null;
        }
      });
    };

    // handle Emitted update
    const handleUpdate = () => {
      if (!canReviewAuthorization.value) {
        return;
      }

      if ((editClaim.value && !isSecondaryCareApproval(editClaim.value)) || (deleteClaim.value && !isSecondaryCareApproval(deleteClaim.value))) {
        handleClear();
        return;
      }

      if (amt.value && qty.value && claim.value && comment.value) {

        if (editClaim.value) {
          // edit here
          response.value.claims.forEach((x) => {
            if (x.id === editClaim.value?.id) {
              if (Number(amt.value) <= Number(x.sent_price)) { // approved_price // worked!
                x.approved_price = Number(amt.value).toFixed(2);
                x.approved_qty = qty.value;
                x.comment = comment.value;
                x.status = "a" // keep at active
              }
            }
          })
        }
        if (deleteClaim.value) {
          // delete here
          response.value.claims.forEach((x) => {
            if (x.id === deleteClaim.value?.id) {
              x.approved_price = 0;
              x.approved_qty = 0;
              x.comment = comment.value;
              x.authorization = "z"; // return to at z
              x.status = "d" // turn to delete
            }
          })
        }

        // load comments
        restartComments();

      }

      // clear all
      handleClear();

    };

    // hanlde restart
    const handleRestart = () => {
      if (props.inline) {
        context.emit("close", { scheme: encounter.value?.scheme });
        return;
      }

      // Go back Home
      router.push({
        name: "auth"
      });
    };

    // handle auth
    const revealAddAuthPanel = () => {
      const scrollPanelIntoView = () => {
        const target = addAuthPanel.value;

        if (!target) {
          return;
        }

        target.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });

        let parent = target.parentElement;
        while (parent && parent !== document.body) {
          if (parent.scrollHeight > parent.clientHeight) {
            parent.scrollTo({
              top: parent.scrollHeight,
              behavior: "smooth",
            });
          }
          parent = parent.parentElement;
        }

        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      };

      setTimeout(scrollPanelIntoView, 80);
      setTimeout(scrollPanelIntoView, 260);
      setTimeout(scrollPanelIntoView, 520);
    };

    const handleAddAuth = async () => {
      if (addAuthLocked.value) {
        return;
      }

      addAuth.value = !addAuth.value;
      if (addAuth.value) {
        await nextTick();
        revealAddAuthPanel();
      }
    }

    // handle auth
    const handleAddAuthUpdate = async (val) => {
      if (addAuthLocked.value) {
        return;
      }

      // clear old errors
      error.value = false;

      /* Auth
       Go Back
      */
      if (val?.id === 'clearAuth') {
        // start
        handleAddAuth();
      }

      /* AUTH
        Add New Authorization
        to the server
      */
      if (val?.id === 'addNewAuth') {

        // start
        isSubmitting.value = true;

        // update
        let newVal = {
          encounter_id: encounter.value.id,
          item: val.value.claim,
          sent_qty: val.value.qty,
          sent_price: val.value.amt,
          approved_qty: null,
          approved_price: null,
          standard_price: val.value.standard,
          authorization_code: null,
          authorization: "z",
          status: "a",
          slug: store.state.user.slug,
        };

        // post update
        const requestEcho = beginAdminAuthorizationRequest({ store, encounter: encounter.value, itemCount: 1 });
        const { res, err } = await postResource.value("claim", newVal);

        if (res.value) {
          requestEcho.finish(res.value.data);

          originalClaimStates.value = {
            ...originalClaimStates.value,
            ...snapshotClaimStates([res.value.data]),
          };

          // sort
          enrolleeDefault.value.claims.push({
            ...res.value.data,
          });

          response.value.claims.push({
            ...res.value.data,
          });

          // notify
          M.toast({
            html: "Item added <i class='material-icons'>check_circle</i>",
            classes: "green",
            displayLength: 4000,
            inDuration: 300,
            outDuration: 300,
          });

          // clear
          addAuth.value = false;

        } else {
          requestEcho.cancel();
          error.value = err.value;
        }

        // clear
        isSubmitting.value = false;

      }

      // top
      moveToSection("claim");
    }

    // confirmation
    const openApproveConfirm = () => {
      if (isSubmitting.value || !canReviewAuthorization.value || !hasSubmitWork.value) {
        return;
      }

      showApproveConfirm.value = true;
    };

    const handleConfirm = (val) => {
      showApproveConfirm.value = false;

      if (!canReviewAuthorization.value) {
        return;
      }

      // call submit if confirmed
      if (val) {
        handleSubmit();
      }
    }

    // handle final submit
    const handleSubmit = async () => {
      if (!canReviewAuthorization.value || !hasSubmitWork.value) {
        return;
      }

      // start
      isSubmitting.value = true;

      // clean up encounter
      let keysToRemove = ["scheme", "claims", "created_at", "updated_at"];
      let newEncounter = {
        ...Object.fromEntries(
          Object.entries(encounter.value).filter(
            ([key]) => !keysToRemove.includes(key)
          )
        ),
      };

      // newEncounter.payer_id = 1; // this wont be necessary once enrollee is loaded properly

      // setup claims
      let newClaims = [];

      // clean up claims
      encounter.value.claims
        .filter((x) => isOriginalActiveAuthorizationClaim(x))
        .forEach((x) => {
          if (isSecondaryCareApproval(x)) {
            // load
            newClaims.push({ ...x, authorization: "y", authorization_code: `${ABBR}-AUTH-${x.id}`, slug: store.state.user.slug });
          } else if (isReturnedNormalClaim(x)) {
            // load
            newClaims.push({ ...x, authorization: "n", authorization_code: null, approved_qty: null, approved_price: null, comment: null, slug: store.state.user.slug });
          } else if (isDeclinedSecondaryCare(x)) {
            // load
            newClaims.push({ ...x, slug: store.state.user.slug });
          }
        });

      // put all together
      let newVal = { encounter: newEncounter, claims: newClaims };

      // post item
      const endpoint = siloMode ? "claim/update/bulk" : `integration/oneprovider/auth/${encounter.value.id}/decision`;
      const { res, err } = await postResource.value(endpoint, newVal);

      if (res.value) {

        // reset
        resetScrollBar();

        // notify
        M.toast({
          html: "Done <i class='material-icons'>check_circle</i>",
          classes: "green",
          displayLength: 5000,
          inDuration: 300,
          outDuration: 300,
        });

        if (props.inline) {
          context.emit("saved");
          return;
        }

        // fly away!
        handleRestart();


      } else {

        // manage error
        error.value = err.value;
        isSubmitting.value = false; // end

        // reset on fail
        resetScrollBar();

      }

    };

    // output encounter results
    const encounter = computed(() => {
      if (!response.value) {
        return null;
      } else {

        // for pending encounters only
        response.value.claims.forEach((x) => {
          if (!x.approved_price && x.status === "a" && x.authorization === "z") {
            x.approved_qty = x.sent_qty;
            x.approved_price = x.sent_price;
          }
        });

        // return
        return response.value;
      }
    });

    const authSubmitSummary = computed(() => {
      return (encounter.value?.claims || []).reduce((summary, x) => {
        if (isSecondaryCareApproval(x)) {
          summary.secondary += 1;
        }

        if (isReturnedNormalClaim(x)) {
          summary.normal += 1;
        }

        if (isDeclinedSecondaryCare(x)) {
          summary.declined += 1;
        }

        return summary;
      }, { secondary: 0, normal: 0, declined: 0 });
    });

    const authSubmitSummaryRows = computed(() => {
      const summary = authSubmitSummary.value;
      const rows = [];

      if (summary.secondary) {
        rows.push({
          id: "secondary",
          icon: "check_circle",
          label: `Approve ${summary.secondary} secondary care ${itemLabel(summary.secondary)}`,
        });
      }

      if (summary.normal) {
        rows.push({
          id: "normal",
          icon: "undo",
          label: `Return ${summary.normal} ${itemLabel(summary.normal)} to normal claim ${itemLabel(summary.normal)}`,
        });
      }

      if (summary.declined) {
        rows.push({
          id: "declined",
          icon: "cancel",
          label: `Decline ${summary.declined} secondary care ${itemLabel(summary.declined)}`,
        });
      }

      return rows;
    });

    const hasSubmitWork = computed(() => authSubmitSummaryRows.value.length > 0);


    return {
      lock,
      enrolleeDefault,
      authSubmitSummaryRows,
      capWords,
      toMoney,
      showAgeSex,
      handleRestart,
      handleAddAuth,
      handleAddAuthUpdate,
      handleCareAuthorization,
      handleActive,
      handleActiveState,
      handlePricing,
      handleReset,
      handleReview,
      handleUpdate,
      handleClear,
      openApproveConfirm,
      handleConfirm,
      handleSubmit,
      alertTitle,
      alertMessage,
      selectedItem,
      totalApproved,
      totalClaimValue,
      benefitPlanId,
      isReady,
      isLoading,
      isRefreshing,
      isSubmitting,
      home,
      tabs,
      tabsState,
      showMessageTabNew,
      encounterMessages,
      messageDraft,
      currTab,
      currState,
      error,
      addAuth,
      addAuthPanel,
      showApproveConfirm,
      showLegacyExternalResolver,
      editClaim,
      deleteClaim,
      encounter,
      orderedReviewClaims,
      hasMixedReviewStates,
      lastPendingReviewClaimId,
      pendingReviewCount,
      reviewedHistoryCount,
      isMixedHistoryClaim,
      hasSubmitWork,
      isPrimaryCareApproval,
      isSecondaryCareApproval,
      isReturnedNormalClaim,
      isDeclinedSecondaryCare,
      isReviewedAuthorizationClaim,
      isReviewReadOnlyClaim,
      isBackendClaimItem,
      isApprovedAsSent,
      claimLineClass,
      hasActiveAuthorizationRequest,
      canReviewAuthorization,
      claimsLocked,
      claimsLockLabel,
      encounterAddLocked,
      addAuthLocked,
      addAuthLockLabel,
      standard,
      comment,
      claim,
      qty,
      amt,
    };
  },
};
</script>

<style scoped>
.auth-inline-detail {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 18px 32px -30px rgba(38, 50, 56, 0.72);
  box-sizing: border-box;
  padding: 0;
  position: relative;
  width: 100%;
}

.auth-inline-detail::before {
  background: linear-gradient(180deg, rgba(38, 50, 56, 0.16) 0%, rgba(38, 50, 56, 0.07) 42%, rgba(38, 50, 56, 0) 100%);
  content: "";
  display: none;
  height: 28px;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
}

.auth-inline-leader,
.auth-inline-switch,
.auth-created-guide,
.auth-inline-review-card,
.auth-inline-secondary-card,
.auth-diagnosis-card,
.auth-inline-items-card,
.auth-inline-add-shell {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.auth-inline-leader {
  align-items: center;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #e1e8eb;
  border-radius: 0;
  display: flex;
  gap: 18px;
  justify-content: space-between;
  padding: 22px 24px;
}

.auth-inline-leader-main {
  align-items: center;
  display: flex;
  gap: 14px;
  min-width: 0;
}

.auth-inline-status {
  align-items: center;
  background: #e8f3f2;
  border: 1px solid #b2dfdb;
  border-radius: 50%;
  color: #00796b;
  display: inline-flex;
  flex: 0 0 auto;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.auth-inline-status.is-waiting {
  background: #ffebee;
  border-color: #ffcdd2;
  color: #b71c1c;
}

.auth-inline-status i {
  font-size: 23px;
}

.auth-inline-leader h5 {
  color: #263238;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.25;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
}

.auth-inline-leader p {
  align-items: center;
  color: #607d8b;
  display: flex;
  flex-wrap: wrap;
  font-weight: 600;
  gap: 8px;
  margin: 6px 0 0;
}

.auth-inline-leader p strong {
  color: #263238;
}

.auth-inline-meta-chips {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
}

.auth-inline-meta-chips span {
  background: #f8fafb;
  border: 1px solid #e1e8eb;
  border-radius: 999px;
  color: #455a64;
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.2;
  padding: 7px 11px;
}

.auth-inline-meta-chips span.is-locked {
  align-items: center;
  background: #fff8e1;
  border-color: #ffcc80;
  color: #5d4037;
  gap: 5px;
}

.auth-inline-meta-chips span.is-locked i {
  color: #ef6c00;
  font-size: 15px;
  line-height: 1;
}

.auth-inline-dot {
  background: #cfd8dc;
  border-radius: 50%;
  display: inline-block;
  height: 5px;
  width: 5px;
}

.auth-inline-back-action {
  align-items: center;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: none;
  color: #455a64;
  display: inline-flex;
  flex: 0 0 auto;
  font-weight: 700;
  min-height: 38px;
  padding: 0 14px;
  transition: background-color 0.18s ease, box-shadow 0.18s ease, color 0.18s ease;
}

.auth-inline-back-action:hover,
.auth-inline-back-action:focus {
  background: #f8fafb;
  box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
  color: #263238;
}

.auth-inline-back-action i {
  color: inherit;
  font-size: 20px;
}

.auth-inline-item-close-action {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  box-shadow: 0 6px 14px -12px rgba(38, 50, 56, 0.75);
  color: #455a64;
}

.auth-inline-item-close-action:hover,
.auth-inline-item-close-action:focus {
  background: #f8fafb;
  box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
  color: #263238;
}

.auth-inline-item-close-action i {
  color: inherit;
}

.auth-inline-close {
  align-items: center;
  background: #ffffff;
  border: 1px solid #d8e2e6;
  border-left: 0;
  border-radius: 999px 6px 6px 999px;
  box-shadow: 0 10px 20px -20px rgba(38, 50, 56, 0.72);
  color: #455a64;
  display: inline-flex;
  flex: 0 0 auto;
  font-weight: 700;
  min-height: 34px;
  padding: 0 12px 0 0;
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, color 160ms ease, transform 160ms ease;
}

.auth-inline-close:hover,
.auth-inline-close:focus {
  background: #f8fafb;
  border-color: #c4d3d9;
  box-shadow: 0 12px 22px -20px rgba(38, 50, 56, 0.82);
  color: #263238;
  transform: translateY(-1px);
}

.auth-inline-close i {
  align-items: center;
  background: #263238;
  border: 1px solid #263238;
  border-radius: 50%;
  color: #ffffff;
  display: inline-flex;
  font-size: 18px;
  height: 34px;
  justify-content: center;
  line-height: 1;
  margin-left: -1px;
  margin-right: 9px;
  width: 34px;
}

.auth-inline-close:hover i,
.auth-inline-close:focus i {
  background: #b71c1c;
  border-color: #b71c1c;
}

.auth-inline-switch {
  background: #ffffff;
  border: 0;
  border-bottom: 0;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  display: flex;
  gap: 0;
  justify-content: center;
  margin: 0;
  max-width: 100%;
  padding: 0 14px !important;
  position: relative;
  text-align: center;
  width: 100%;
  z-index: 1;
}

.auth-inline-switch .tab-custom,
.auth-inline-switch .tab-custom-active {
  align-items: center;
  border: 0;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.82rem;
  font-weight: 800;
  justify-content: center;
  line-height: 1.15;
  margin: 0;
  min-height: 46px;
  padding: 0 22px;
  text-transform: uppercase;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.auth-message-tab-new {
  background: #fff3cd;
  border: 1px solid #ffe082;
  border-radius: 3px;
  color: #8d5b00;
  display: inline-block;
  font-size: 0.66rem;
  font-weight: 800;
  line-height: 1;
  margin-left: 6px;
  padding: 4px 6px;
  text-transform: uppercase;
}

.auth-inline-switch .tab-custom {
  background: transparent;
  color: #607d8b;
  box-shadow: none;
}

.auth-inline-switch .tab-custom-active {
  background: transparent;
  border-bottom-color: #263238;
  color: #263238;
  box-shadow: none;
}

.auth-inline-switch .tab-custom:hover {
  background: #f4f7f8;
  color: #263238;
}

.auth-created-guide {
  align-items: center;
  background: #ffffff;
  border: 1px solid #dbe5e9;
  border-radius: 6px;
  box-shadow: none;
  display: flex;
  gap: 12px;
  margin: 14px 24px 18px;
  padding: 12px 14px;
}

.auth-created-guide-icon {
  align-items: center;
  background: #f8fafb;
  border: 1px solid #cde8e5;
  border-radius: 50%;
  color: #00695c;
  display: inline-flex;
  flex: 0 0 auto;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.auth-created-guide-icon i {
  font-size: 18px;
}

.auth-created-guide-copy {
  flex: 1 1 auto;
  min-width: 0;
}

.auth-created-guide-copy span {
  color: #455a64;
  display: block;
  font-size: 0.76rem;
  font-weight: 750;
  text-transform: uppercase;
}

.auth-created-guide-copy p {
  color: #607d8b;
  font-size: 0.92rem;
  line-height: 1.45;
  margin: 3px 0 0;
}

.auth-created-guide-copy strong {
  color: #263238;
}

.auth-created-guide-action {
  align-items: center;
  background: #ffffff;
  border: 1px solid #d2e2e6;
  border-radius: 6px;
  color: #455a64;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.78rem;
  font-weight: 750;
  gap: 7px;
  min-height: 34px;
  padding: 0 11px;
  text-transform: uppercase;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.auth-created-guide-action:hover {
  background: #eef5f6;
  border-color: #c4d3d9;
  color: #263238;
}

.auth-created-guide-action i {
  font-size: 17px;
}

.auth-inline-detail > .section:not(.auth-inline-switch) {
  padding-bottom: 0;
  padding-top: 0;
}

.auth-inline-detail > div > div > .section {
  padding-top: 0;
}

.auth-inline-detail .card {
  border-radius: 6px;
}

.auth-inline-inner-card {
  background: transparent !important;
  border: none;
  box-shadow: none;
  margin: 0;
  padding: 0 !important;
}

.auth-inline-review-card {
  background: #ffffff !important;
  border: 0;
  border-top: 1px solid #e1e8eb;
  border-radius: 0 !important;
  box-sizing: border-box;
  box-shadow: none;
  margin: 0;
  overflow: visible;
  padding: 0 0 20px !important;
  width: 100%;
}

.auth-inline-secondary-card {
  background: #ffffff;
  border: 0;
  border-top: 1px solid #e1e8eb;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  margin: 0;
  overflow: visible;
  padding: 20px !important;
}

.auth-inline-secondary-card :deep(.card) {
  border-bottom: 1px solid #e1e8eb !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin: 0;
  padding: 0 !important;
}

.auth-inline-secondary-card :deep(.card:last-child) {
  border-bottom: 0 !important;
}

.auth-inline-secondary-card :deep(nav) {
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  box-shadow: none !important;
  margin-bottom: 16px;
  overflow: hidden;
}

.auth-inline-secondary-card :deep(.card-panel) {
  border-bottom: 1px solid #e1e8eb !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin: 0;
  padding-bottom: 18px !important;
  padding-top: 18px !important;
}

.auth-inline-secondary-card :deep(.card-panel + .card-panel) {
  border-top: 1px solid #ffffff !important;
}

.auth-inline-secondary-card :deep(.card-panel:last-child) {
  border-bottom: 1px solid #e1e8eb !important;
}

.auth-inline-secondary-card :deep(> .card > .card-panel:first-child) {
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
}

.auth-inline-secondary-card :deep(> .card > .card-panel:last-child) {
  border-bottom-left-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

.auth-diagnosis-card {
  align-items: center;
  background: #f8fafb;
  border: 2px solid #cddde2;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  gap: 14px;
  margin: 20px 20px 0;
  padding: 15px 18px;
}

.auth-diagnosis-icon {
  align-items: center;
  background: #e8f3f2;
  border: 1px solid #cde8e5;
  border-radius: 6px;
  color: #00897b;
  display: inline-flex;
  flex: 0 0 auto;
  height: 38px;
  justify-content: center;
  width: 38px;
}

.auth-diagnosis-icon i {
  font-size: 21px;
}

.auth-diagnosis-copy {
  min-width: 0;
}

.auth-diagnosis-copy span {
  color: #607d8b;
  display: block;
  font-size: 0.72rem;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.auth-diagnosis-copy p {
  color: #263238;
  font-weight: 650;
  line-height: 1.4;
  margin: 0;
  overflow-wrap: anywhere;
}

.auth-diagnosis-copy p.is-muted {
  color: #78909c;
  font-weight: 600;
}

.auth-inline-review-card > .card,
.auth-inline-review-card > .card.grey.lighten-5,
.auth-inline-review-card > .card.teal.lighten-5,
.auth-inline-review-card > .card.red.lighten-5 {
  border: 1px solid #e1e8eb;
  box-shadow: none;
  margin: 18px 20px 0;
}

.auth-inline-review-card > .card.grey.lighten-5 {
  background: #ffffff !important;
}

.auth-inline-review-card > .auth-inline-items-card {
  box-sizing: border-box;
  margin-left: 20px;
  margin-right: 20px;
  max-width: calc(100% - 40px);
  width: auto;
}

.auth-inline-review-progress {
  border-radius: 0;
  margin: 0 20px 18px;
  max-width: calc(100% - 40px);
  overflow: hidden;
  width: auto;
}

.auth-inline-review-card .card-content {
  color: #263238;
}

.auth-inline-review-card .card-title {
  color: #263238;
  font-size: 1.05rem;
  font-weight: 700;
}

.auth-inline-review-card .collection {
  border-color: #e1e8eb;
  border-radius: 6px;
  overflow: hidden;
}

.auth-inline-review-card .collection-item {
  border-bottom-color: #edf2f4;
  line-height: 1.45;
}

.auth-inline-review-card .auth-line-item {
  box-sizing: border-box;
  min-height: 54px;
  padding-right: 166px;
  position: relative;
}

.auth-mixed-section-heading {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.auth-mixed-section-heading > span {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.auth-mixed-section-heading i {
  font-size: 19px;
  line-height: 1;
}

.auth-mixed-section-heading strong {
  color: #263238;
  font-size: 0.9rem;
}

.auth-mixed-section-heading small {
  color: #607d8b;
  font-size: 0.76rem;
  font-weight: 600;
}

.auth-mixed-section-heading.is-pending {
  background: #fffaf0;
  border: 1px solid #eadca9;
  border-bottom: 0;
  border-radius: 4px 4px 0 0;
  color: #9a6700;
  padding: 11px 14px;
}

.auth-inline-review-card .auth-mixed-section-heading.is-reviewed {
  background: #f4f7f8;
  border-bottom: 1px solid #dce5e8;
  border-top: 1px solid #cbd8dd;
  box-sizing: border-box;
  color: #455a64;
  list-style: none;
  margin-left: -40px;
  padding: 12px 16px;
  width: calc(100% + 40px);
}

.auth-inline-review-card .auth-mixed-section-heading.is-reviewed::marker,
.auth-inline-review-card .auth-mixed-action-zone::marker {
  content: "";
}

.auth-inline-review-card .auth-mixed-action-zone {
  background: #ffffff;
  border-bottom: 0;
  box-sizing: border-box;
  list-style: none;
  margin-left: -40px;
  padding: 18px 16px;
  width: calc(100% + 40px);
}

.auth-mixed-action-heading {
  align-items: flex-start;
  display: flex;
  gap: 8px 14px;
  justify-content: space-between;
  margin-bottom: 12px;
}

.auth-mixed-action-heading > span {
  align-items: center;
  color: #00796b;
  display: inline-flex;
  gap: 8px;
}

.auth-mixed-action-heading i {
  font-size: 20px;
}

.auth-mixed-action-heading strong {
  color: #263238;
  font-size: 0.9rem;
}

.auth-mixed-action-heading small {
  color: #607d8b;
  font-size: 0.76rem;
  font-weight: 600;
  text-align: right;
}

.auth-mixed-total-list {
  margin: 10px 0 14px;
}

.auth-mixed-action-buttons {
  align-items: center;
  display: flex;
  gap: 14px;
  justify-content: space-between;
  margin-bottom: 14px;
}

.auth-mixed-action-buttons .auth-inline-back-action,
.auth-mixed-action-buttons .auth-submit-action {
  min-width: 180px;
}

.auth-inline-review-card .auth-line-item.has-inline-resolver {
  background: #fbfdfd !important;
  padding-right: 24px;
}

.auth-inline-review-card .auth-line-item.is-inline-editing {
  box-shadow: inset 3px 0 0 #00897b;
}

.auth-inline-review-card .auth-line-item.is-inline-deleting {
  background: #fffdfb !important;
  box-shadow: inset 3px 0 0 #ef6c00;
}

.auth-inline-review-card .auth-line-item.has-inline-resolver > .auth-line-copy {
  padding-right: 142px;
}

.auth-item-resolver {
  background: #f8fbfb;
  border: 1px solid #d8e5e8;
  border-radius: 4px;
  box-sizing: border-box;
  display: grid;
  gap: 14px;
  margin-top: 14px;
  padding: 14px;
  width: 100%;
}

.auth-item-resolver.is-deleting {
  background: #fff8f2;
  border-color: #ffd5ad;
}

.auth-item-resolver-heading {
  align-items: center;
  display: flex;
  gap: 10px;
}

.auth-item-resolver-heading > span:last-child {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.auth-item-resolver-heading strong {
  color: #263238;
  font-size: 0.92rem;
  line-height: 1.25;
}

.auth-item-resolver-heading small {
  color: #607d8b;
  font-size: 0.78rem;
  line-height: 1.35;
  margin-top: 2px;
  overflow-wrap: anywhere;
}

.auth-item-resolver-dismiss {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cfdde2;
  border-radius: 4px;
  color: #607d8b;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  height: 34px;
  justify-content: center;
  margin-left: auto;
  padding: 0;
  width: 34px;
}

.auth-item-resolver-dismiss:hover,
.auth-item-resolver-dismiss:focus {
  background: #fff3e0;
  border-color: #ffb74d;
  color: #e65100;
  outline: none;
}

.auth-item-resolver-dismiss i {
  font-size: 19px;
  line-height: 1;
}

.auth-item-resolver-icon {
  align-items: center;
  background: #e4f3f1;
  border: 1px solid #b9ddd8;
  border-radius: 4px;
  color: #00796b;
  display: inline-flex;
  flex: 0 0 auto;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.auth-item-resolver.is-deleting .auth-item-resolver-icon {
  background: #fff0e3;
  border-color: #ffc58f;
  color: #d95f00;
}

.auth-item-resolver-icon i {
  font-size: 19px;
  line-height: 1;
}

.auth-item-resolver-fields {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.auth-item-resolver label {
  color: #546e7a;
  display: grid;
  font-size: 0.76rem;
  font-weight: 700;
  gap: 5px;
  letter-spacing: 0;
}

.auth-item-resolver input[type="number"],
.auth-item-resolver input[type="text"] {
  background: #ffffff;
  border: 1px solid #cfdde2 !important;
  border-radius: 4px;
  box-shadow: none !important;
  box-sizing: border-box;
  color: #263238;
  font-size: 0.9rem;
  height: 40px;
  margin: 0;
  padding: 0 11px;
  width: 100%;
}

.auth-item-resolver input[readonly] {
  background: #f1f5f6;
  color: #455a64;
}

.auth-item-resolver input:focus {
  border-color: #00897b !important;
}

.auth-item-resolver.is-deleting input:focus {
  border-color: #ef6c00 !important;
}

.auth-item-resolver-actions {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.auth-item-resolver-actions button {
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  gap: 6px;
  justify-content: center;
  letter-spacing: 0;
  min-height: 36px;
  padding: 7px 12px;
}

.auth-item-resolver-cancel {
  background: #ffffff;
  border: 1px solid #cfdde2;
  color: #546e7a;
}

.auth-item-resolver-submit {
  background: #00796b;
  border: 1px solid #00796b;
  color: #ffffff;
}

.auth-item-resolver-submit.is-danger {
  background: #ffffff;
  border-color: #ef6c00;
  color: #d95f00;
}

.auth-item-resolver-actions button:hover,
.auth-item-resolver-actions button:focus {
  filter: brightness(0.97);
  outline: none;
}

.auth-item-resolver-actions i {
  font-size: 17px;
  line-height: 1;
}

.auth-inline-review-card .auth-line-item.is-reviewed-authorization::marker {
  color: #607d8b;
  content: "    R. ";
  font-weight: 800;
}

.auth-inline-review-card .auth-line-item.is-claim-item::marker {
  color: #607d8b;
  content: "    C. ";
  font-weight: 800;
}

.auth-inline-review-card .auth-line-item.is-mixed-history-row {
  box-sizing: border-box;
  list-style: none;
  margin-left: -40px;
  padding-left: 24px;
  width: calc(100% + 40px);
}

.auth-inline-review-card .auth-line-item.is-mixed-history-row::marker,
.auth-inline-review-card .auth-line-item.is-mixed-history-row.is-reviewed-authorization::marker,
.auth-inline-review-card .auth-line-item.is-mixed-history-row.is-claim-item::marker {
  content: "";
}

.auth-inline-review-card .auth-line-item.is-review-readonly {
  background: #fefefe !important;
  color: #546e7a;
}

.auth-inline-review-card .auth-line-item.is-review-readonly .auth-line-copy,
.auth-inline-review-card .auth-line-item.is-review-readonly .auth-line-copy b,
.auth-inline-review-card .auth-line-item.is-review-readonly .auth-line-copy s,
.auth-inline-review-card .auth-line-item.is-review-readonly .auth-line-copy .brown-text,
.auth-inline-review-card .auth-line-item.is-review-readonly .auth-line-copy .blue-text,
.auth-inline-review-card .auth-line-item.is-review-readonly .auth-line-copy .black-text,
.auth-inline-review-card .auth-line-item.is-review-readonly .auth-line-copy .red-text {
  color: #546e7a !important;
}

.auth-inline-review-card .auth-line-item.is-review-readonly .auth-care-state-chip {
  background: #fafcfd;
  border-color: #edf2f4;
  color: #607d8b;
}

.auth-inline-review-card .auth-line-copy {
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: break-word;
}

.auth-inline-review-card .line-item-actions {
  align-items: center;
  display: inline-flex;
  gap: 6px;
  justify-content: flex-end;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
}

.auth-inline-review-card .line-item-actions .secondary-content {
  float: none;
  margin-left: 0;
  position: static;
}

.auth-inline-review-card .auth-readonly-line-icon.secondary-content {
  align-items: center;
  display: inline-flex;
  float: none;
  height: 32px;
  justify-content: center;
  margin-left: 0;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
}

.auth-inline-review-card .auth-readonly-line-icon i {
  line-height: 1;
}

.auth-inline-review-card .auth-reviewed-lock-chip {
  align-items: center;
  background: #f4f7f8;
  border: 1px solid #d6e0e4;
  border-radius: 999px;
  color: #455a64;
  display: inline-flex;
  font-size: 0.72rem;
  font-weight: 750;
  gap: 5px;
  line-height: 1.1;
  padding: 5px 9px;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
}

.auth-inline-review-card .auth-reviewed-lock-chip.is-declined {
  background: #fff5f5;
  border-color: #ffcdd2;
  color: #b71c1c;
}

.auth-inline-review-card .auth-reviewed-lock-chip i {
  font-size: 15px;
  line-height: 1;
}

.auth-inline-review-card .line-item-actions a {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  position: relative;
  width: 30px;
}

.auth-inline-review-card .line-item-actions a + a::before {
  background: #c4d3d9;
  content: "";
  height: 20px;
  left: -3px;
  position: absolute;
  top: 5px;
  width: 1px;
}

.auth-inline-review-card .line-item-actions i {
  line-height: 1;
}

.auth-line-transition-prefix {
  align-items: center;
  background: #eef7f8;
  border: 1px solid #c6e2e7;
  border-radius: 50%;
  color: #00796b;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  margin-right: 8px;
  vertical-align: middle;
  width: 28px;
}

.auth-line-transition-prefix:hover,
.auth-line-transition-prefix:focus {
  background: #d8f0ef;
}

.auth-line-transition-prefix.is-returned {
  background: #fff8e1;
  border-color: #ffcc80;
  color: #ef6c00;
}

.auth-line-transition-prefix i {
  color: inherit;
  font-size: 18px;
  line-height: 1;
}

.auth-care-state-chip {
  background: #eef2f4;
  border: 1px solid #d6e0e4;
  border-radius: 999px;
  color: #455a64;
  display: inline-flex;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.2;
  margin-left: 8px;
  padding: 4px 8px;
  vertical-align: middle;
}

.auth-care-state-chip.is-static {
  margin-left: 0;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
}

.auth-care-state-chip.is-secondary {
  background: #e8f5e9;
  border-color: #c8e6c9;
  color: #2e7d32;
}

.auth-care-state-chip.is-primary {
  background: #e3f2fd;
  border-color: #bbdefb;
  color: #1565c0;
}

.auth-care-state-chip.is-normal {
  background: #f8fafb;
  border-color: #dbe5e9;
  color: #607d8b;
}

.auth-care-state-chip.is-return {
  background: #fff8e1;
  border-color: #ffcc80;
  color: #ef6c00;
}

.auth-care-state-chip.is-approved {
  background: #e8f5e9;
  border-color: #a5d6a7;
  color: #1b5e20;
}

.auth-care-state-chip.is-declined {
  background: #ffebee;
  border-color: #ffcdd2;
  color: #b71c1c;
}

.auth-submit-action {
  align-items: center;
  background: #0b8f78 !important;
  border: 1px solid #087a68;
  border-radius: 7px;
  box-shadow: 0 12px 24px -16px rgba(8, 122, 104, 0.95);
  color: #ffffff !important;
  display: inline-flex;
  font-size: 0.95rem;
  font-weight: 800;
  justify-content: center;
  letter-spacing: 0;
  min-height: 52px;
  text-transform: none;
  transition: background-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.auth-submit-action:hover,
.auth-submit-action:focus {
  background: #087a68 !important;
  box-shadow: 0 16px 30px -18px rgba(8, 122, 104, 0.95);
  transform: translateY(-1px);
}

.auth-submit-action.disabled,
.auth-submit-action:disabled {
  background: #cfd8dc !important;
  border-color: #cfd8dc;
  box-shadow: none;
  color: #607d8b !important;
  transform: none;
}

.auth-submit-action i.left {
  color: inherit;
  font-size: 22px;
  line-height: 1;
  margin-right: 10px;
}

.auth-inline-review-card .collection-item.pull-right {
  background: #f8fafb;
  color: #263238;
}

.auth-inline-review-card .auth-total-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
  justify-content: space-between;
}

.auth-inline-review-card .auth-grand-total {
  color: #000000;
  margin-left: auto;
}

.auth-inline-add-shell {
  box-sizing: border-box;
  margin: 8px 20px 0;
  max-width: calc(100% - 40px);
  overflow: visible;
  position: relative;
  z-index: 10;
}

.auth-inline-add-shell :deep(.card) {
  background: #ffffff !important;
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  box-shadow: none;
  box-sizing: border-box;
  margin: 0;
  overflow: visible;
  width: 100%;
}

.auth-inline-add-shell :deep(.card-content) {
  box-sizing: border-box;
  padding: 22px;
}

.auth-inline-add-shell :deep(.row) {
  margin-left: 0;
  margin-right: 0;
}

.auth-inline-add-shell :deep(form.col.s12) {
  padding-left: 0;
  padding-right: 0;
}

.auth-inline-add-shell :deep(.add-auth-item-card),
.auth-inline-add-shell :deep(.add-auth-item-card .card-content),
.auth-inline-add-shell :deep(.add-auth-item-card form),
.auth-inline-add-shell :deep(.add-auth-item-card .row),
.auth-inline-add-shell :deep(.add-auth-item-card .input-field) {
  overflow: visible !important;
}

.auth-inline-add-shell :deep(.add-auth-item-card) {
  position: relative;
  z-index: 20;
}

.auth-inline-add-shell :deep(.add-auth-item-card .autocomplete-content.dropdown-content) {
  max-height: 320px;
  overflow-y: auto;
  z-index: 1200;
}

.auth-add-slide-enter-active,
.auth-add-slide-leave-active {
  overflow: hidden;
  transition:
    max-height 0.42s ease,
    opacity 0.26s ease,
    transform 0.42s ease;
}

.auth-add-slide-enter-from,
.auth-add-slide-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
}

.auth-add-slide-enter-to,
.auth-add-slide-leave-from {
  max-height: 620px;
  opacity: 1;
  transform: translateY(0);
}

.progress {
  margin-top: -15px;
}

.progress.auth-inline-review-progress {
  margin-top: 0;
}

.spacer5 {
  padding-top: 5px;
  padding-bottom: 5px;
}

.spacerTop10 {
  padding-top: 10px;
  padding-bottom: 0px;
}

.edit-black-item:hover .material-icons.black-text,
.edit-black-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

.edit-item:hover .material-icons.grey-text,
.edit-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

.cancel-item:hover .material-icons.grey-text,
.cancel-item:hover .material-icons.grey-text::before {
  color: rgb(214, 16, 16) !important;
}

.return-normal-item:hover .material-icons.grey-text,
.return-normal-item:hover .material-icons.grey-text::before {
  color: #ef6c00 !important;
}

.custom-nav {
  height: 15px;
}

.nav-extended .nav-wrapper {
  padding: 0 20px;
}

.brand-logo {
  font-weight: 300;
  font-size: 1.5rem;
}

.nav-wrapper ul li a {
  font-weight: 400;
  padding: 0 15px;
}

.nav-content {
  min-height: 20px;
}

@media only screen and (max-width: 992px) {
  .auth-inline-detail {
    background: transparent;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .auth-inline-leader {
    border: 1px solid #e1e8eb;
    border-radius: 8px;
    margin-bottom: 8px;
    padding: 18px;
  }

  .auth-inline-switch {
    align-items: stretch;
    flex-wrap: wrap;
    gap: 0;
    justify-content: center;
    padding: 0 14px !important;
  }

  .auth-inline-switch .tab-custom,
  .auth-inline-switch .tab-custom-active {
    background: transparent;
    border: 0;
    border-bottom: 3px solid transparent;
    border-radius: 0;
    box-sizing: border-box;
    color: #607d8b;
    float: none !important;
    flex: 0 0 auto;
    font-size: 0.82rem;
    justify-content: center;
    min-height: 46px;
    padding: 0 22px;
    text-align: center;
  }

  .auth-inline-switch .tab-custom-active {
    background: transparent;
    border-bottom-color: #263238;
    color: #263238;
  }

  .auth-inline-switch .tab-custom:hover {
    background: #f4f7f8;
    color: #263238;
  }

  .auth-inline-detail > .section:not(.auth-inline-switch),
  .auth-inline-detail > div > div > .section {
    padding: 0;
  }

  .auth-inline-inner-card,
  .auth-inline-review-card {
    background: transparent !important;
    border: 0;
    box-shadow: none;
  }

  .auth-inline-review-card {
    padding: 0 0 16px !important;
  }

  .auth-diagnosis-card,
  .auth-inline-review-card > .card,
  .auth-inline-review-card > .card.grey.lighten-5,
  .auth-inline-review-card > .card.teal.lighten-5,
  .auth-inline-review-card > .card.red.lighten-5,
  .auth-inline-review-card > .auth-inline-items-card {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
    width: 100%;
  }

  .auth-inline-add-shell {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
  }

  .auth-inline-review-progress {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
  }

  .auth-inline-review-card .auth-line-item {
    padding-right: 20px;
  }

  .auth-mixed-section-heading,
  .auth-mixed-action-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .auth-mixed-action-heading small {
    text-align: left;
  }

  .auth-mixed-action-buttons {
    align-items: stretch;
    flex-direction: column-reverse;
  }

  .auth-mixed-action-buttons .auth-inline-back-action,
  .auth-mixed-action-buttons .auth-submit-action {
    justify-content: center;
    margin: 0;
    width: 100%;
  }

  .auth-inline-review-card .auth-line-item.has-inline-resolver > .auth-line-copy {
    padding-right: 0;
  }

  .auth-inline-review-card .auth-line-copy {
    padding-right: 0;
  }

  .auth-inline-review-card .line-item-actions {
    background: #f8fafb;
    border: 1px solid #dbe5e9;
    border-radius: 999px;
    box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
    gap: 10px;
    margin-left: 10px;
    margin-top: 10px;
    padding: 4px;
    position: static;
    transform: none;
    width: max-content;
  }

  .auth-inline-review-card .auth-line-copy .info-item:not(.secondary-content) {
    display: inline-flex;
    margin-right: 10px;
    position: relative;
    top: -0.35em;
    vertical-align: super;
  }

  .auth-inline-review-card .auth-line-copy .info-item:not(.secondary-content) i {
    line-height: 1;
  }

  .auth-inline-review-card .auth-readonly-line-icon.secondary-content {
    display: inline-flex;
    margin-left: 8px;
    position: static;
    transform: none;
    vertical-align: middle;
  }

  .auth-inline-review-card .auth-reviewed-lock-chip {
    margin-left: 8px;
    position: static;
    transform: none;
    vertical-align: middle;
  }

  .auth-inline-review-card .line-item-actions a {
    height: 34px;
    width: 34px;
  }

  .auth-inline-review-card .line-item-actions a + a::before {
    display: none;
  }

  .auth-inline-review-card .line-item-actions .tiny.material-icons {
    font-size: 1.25rem;
  }

  .auth-item-resolver-fields {
    grid-template-columns: 1fr;
  }

  .auth-item-resolver-actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }

  .auth-item-resolver-actions button {
    width: 100%;
  }

  .auth-care-state-chip.is-static {
    margin-left: 8px;
    position: static;
    transform: none;
  }

  .auth-inline-review-card .auth-inline-back-action,
  .auth-inline-item-close-action {
    display: block;
    flex: none;
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
    min-height: 0;
    padding: 0 16px;
    text-align: center;
  }

  .auth-inline-review-card .auth-inline-back-action i.left,
  .auth-inline-item-close-action i.left {
    line-height: 36px;
  }
}

@media only screen and (max-width: 600px) {
  .auth-inline-detail {
    padding: 0;
  }

  .auth-inline-leader {
    align-items: flex-start;
    flex-direction: column;
    padding: 16px;
  }

  .auth-inline-switch .tab-custom,
  .auth-inline-switch .tab-custom-active {
    margin-bottom: 0;
  }

  .auth-created-guide {
    align-items: flex-start;
    flex-direction: column;
    margin: 10px 0;
  }

  .auth-created-guide-action {
    justify-content: center;
    width: 100%;
  }

  .auth-inline-add-shell {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
  }

  .auth-diagnosis-card {
    padding: 12px 14px;
  }

  .auth-inline-review-card .card-content {
    padding: 16px;
  }

  .auth-inline-review-card .collection-item {
    padding: 12px 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .auth-inline-leader,
  .auth-inline-switch,
  .auth-created-guide,
  .auth-inline-review-card,
  .auth-inline-secondary-card,
  .auth-diagnosis-card,
  .auth-inline-items-card,
  .auth-inline-add-shell {
    animation: none;
  }
}
</style>

<style>
.auth-inline-confirm-layer {
  align-items: center;
  background: rgba(20, 31, 38, 0.62);
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 24px;
  position: fixed !important;
  right: 0;
  top: 0;
  z-index: 10050;
}

.auth-inline-confirm-card {
  background: #ffffff;
  border: 1px solid #dbe5e9;
  border-radius: 6px;
  box-shadow: 0 24px 56px rgba(25, 35, 42, 0.34);
  max-width: calc(100vw - 48px);
  overflow: hidden;
  width: 710px;
}

.auth-inline-confirm-content {
  padding: 34px 30px 28px;
}

.auth-inline-confirm-content h4 {
  color: #263238;
  font-size: 2rem;
  font-weight: 400;
  margin: 0 0 20px;
}

.auth-inline-confirm-content p {
  color: #263238;
  font-size: 1rem;
  line-height: 1.45;
  margin: 0;
}

.auth-submit-summary {
  display: grid;
  gap: 9px;
  list-style: none;
  margin: 18px 0 0;
  padding: 0;
}

.auth-submit-summary li {
  align-items: center;
  background: #f8fafb;
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  color: #263238;
  display: flex;
  font-weight: 700;
  gap: 10px;
  min-height: 42px;
  padding: 9px 20px;
}

.auth-submit-summary i {
  align-items: center;
  background: #00796b;
  border-radius: 50%;
  color: #ffffff;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 16px;
  height: 24px;
  justify-content: center;
  line-height: 1;
  width: 24px;
}

.auth-submit-summary li.is-secondary i {
  background: #2e7d32;
}

.auth-submit-summary li.is-primary i {
  background: #1565c0;
}

.auth-submit-summary li.is-normal i {
  background: #ef6c00;
}

.auth-submit-summary li.is-declined i {
  background: #c62828;
}

.auth-confirm-total {
  align-items: center;
  background: #263238;
  border-radius: 7px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  min-height: 52px;
  padding: 12px 14px;
}

.auth-confirm-total span {
  color: #dbe5e9;
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
}

.auth-confirm-total strong {
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: 900;
}

.auth-inline-confirm-actions {
  align-items: center;
  border-top: 1px solid #eef2f4;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 12px 20px;
}

.auth-inline-confirm-actions button {
  background: transparent;
  border: 0;
  color: #263238;
  cursor: pointer;
  font-size: 0.86rem;
  font-weight: 500;
  padding: 9px 13px;
  text-transform: uppercase;
}

.auth-inline-confirm-actions button:hover {
  background: #f3f6f7;
}
</style>
